import React, {useContext} from "react";
import {History} from "history";
import {useHistory} from "react-router-dom";


const Context = React.createContext<History>(null);


export const GlobalHistoryProvider = ({children}) => {
    const history = useHistory();
    return (
        <Context.Provider value={history}>{children}</Context.Provider>
    )
}


export function useGlobalHistory(): History {
    return useContext(Context);
}